module.exports = __webpack_public_path__ + "static/media/DownloadButton.2928664f.svg";